<template>
	<div
		class="case-progress-bar"
		:class="{
			'advanced': advancedMode
		}"
		>

		<Flickity 
			ref="flickity" 
			:options="flickityOptions"
			@init="flickityInit"
			class="progress-row"
			>
			<div 
				v-for="(stage, index) in stages"
				:key="index"
				class="progress-column"
				:class="[
					`stage-${processSteps[index]}`,
					step >= index ? 'mild-stage-highlight' : '',
					stageEditable(step, index) ? 'stage-editable' : ''
				]"
				@click="editStage(index)"
				>
				
				<div class="text-inner">
					<div class="number" v-if="advancedMode">
						{{ index + 1 }}.
					</div>

					<div class="title">
						<div class="subtext" v-if="advancedMode">
							{{ advancedSubText(processSteps[index]) }}
						</div>

						{{ stage }}
					</div>
				</div>

				<div class="icon">
					<i class="fal fa-check" v-if="processSteps[index] == 'done'" />
					<div class="circle-blue" v-if="processSteps[index] == 'current'" />
					<div class="circle-pink" v-if="processSteps[index] == 'todo'" />
					<div class="circle-green" v-if="processSteps[index] == 'scheduled'" />
				</div>
			</div>
		</Flickity>

	</div>
</template>

<script>

import Flickity from 'vue-flickity'

export default {
	components: {
		Flickity
	},
	props: [
		'step', // starts at 0 goes to 4. its an array
		'advancedMode',
		'thisCase',
		'pageStep',
		'permissions'
	],
	data: () => {
		return {
			stages: [
				'Enquiry Submission',
				'Image Submission',
				'Design Meeting',
				'Treatment Plan',
				'Implant Production',
				'Post Market Surveillance'
			],
			stagePaths: [
				'upload-enquiry',
				'image-submission',
				'design-meeting',
				'review-treatment-plan',
				'',
				''
			],
			flickityOptions: {
				prevNextButtons: false,
				pageDots: false,
				wrapAround: false,
				watchCSS: true,
				contain: true
			},
			flickityActive: false
		}
	},
	computed: {
		processSteps(){

			let output = []

			switch(parseInt(this.step)){
				case 0:
					output = ['current','todo','todo','todo','todo','todo']
					break;
				case 1:
					output = ['done','current','todo','todo','todo','todo']
					break;
				case 2:
					output = ['done','done','current','todo','todo','todo']
					break;
				case 3:
					if(this.thisCase){
						if(this.thisCase.override_progress >= 3){
							output = ['done','done','done','current','todo','todo']
						}else{
							
							if(this.thisCase.treatment_plan_deadline != null){
								output = ['done','done','done','current','todo','todo']
							}else{
								output = ['done','done','done','todo','todo','todo']
							}
							
						}							
					}
					break;
				case 4:
					if(this.thisCase != null && this.isInPast(this.thisCase.implant_production_date, '00:00')){
						output = ['done','done','done','done','done','todo']
					}else{
						output = ['done','done','done','done','current','todo']
					}
					break;
				case 5: // PMS active or not
					let implantProductionDone = false
					if(this.thisCase != null && this.isInPast(this.thisCase.implant_production_date, '00:00')){
						implantProductionDone = true
					}

					output = ['done','done','done','done',(implantProductionDone ? 'done' : 'current'),(implantProductionDone ? 'current' : 'pending')]
					break;
				case 6: // PMS complete
					output = ['done','done','done','done','done','done']
					break;
			}

			return output
		},
	},
	beforeDestroy(){
		// console.log('destroy case progress bar')
		this.$refs.flickity.destroy()
	},
	beforeUnmount(){
		// console.log('unmount case progress bar')
		this.$refs.flickity.destroy()
	},
	methods: {
		stageEditable(step, index){
			if(step >= index && this.permissions && this.permissions.canEditProject 
				|| ['admin'].includes(this.$page.props.user.user_type)
				|| ['team_admin'].includes(this.$page.props.user.user_type) && this.permissions && this.permissions.canEditProject 
				){
				return true
			}else{
				return false
			}
		},
		flickityInit(){

			let theStep = this.step
			if(this.pageStep){
				theStep = this.pageStep
			}

			try {
				this.$refs.flickity.selectCell(theStep, false, true)
				this.flickityActive = true
			}catch{
				this.flickityActive = false
			}

			this.$refs.flickity.on('activate', () => {
				this.$refs.flickity.selectCell(theStep, false, true)
				this.flickityActive = true
			})
			this.$refs.flickity.on('deactivate', () => {
				this.flickityActive = false
			})

			this.$refs.flickity.on('destroy', (index) => {
				this.flickityActive = false
			})

			// deals with clicking on the flickity cell
			this.$refs.flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
				if ( !cellElement ) {
					return
				}
				if(this.stageEditable(this.step, cellIndex)){
					this.$inertia.get(`/cases/${this.thisCase.hashid}/${this.stagePaths[cellIndex]}`)
				}
			})


		},
		editStage(index){
			if(!this.flickityActive){
				if(this.stageEditable(this.step, index)){
					this.$inertia.get(`/cases/${this.thisCase.hashid}/${this.stagePaths[index]}`)
				}
			}
		},
		advancedSubText(stage){
			let output = stage

			switch(stage){
				case 'done':
					output = 'complete'
					break;
				case 'todo':
					output = 'next'
					break;
			}

			return output
		},
		isInPast(inputDate, inputTime){
			if(inputDate != null){
				let d = new Date(),
					month = '' + (d.getMonth() + 1),
					day = '' + d.getDate(),
					year = d.getFullYear(),
					hours = d.getHours(),
					minutes = d.getMinutes();

				hours = ("0" + hours).slice(-2);
				minutes = ("0" + minutes).slice(-2);
				day = ("0" + day).slice(-2);
				month = ("0" + month).slice(-2);

				let splitDate = inputDate.split('-').join('')
				let splitTime = inputTime.split(':').join('')

				if(parseInt(splitDate + splitTime) <= parseInt(String(year)+String(month)+String(day) + String(hours)+String(minutes))){
					return true
				}else{
					return false
				}
			}else{
				return false
			}
		},
	}
}
</script>

<style lang="sass">

.case-progress-bar
	width: 100%
	min-height: 75px
	height: auto
	border-radius: 8px
	margin-bottom: 30px
	margin-top: -15px
	box-shadow: 0 1px 3px rgba(#000, 0.2)
	background-color: #fff
	overflow: hidden
	position: relative

	@media (max-width: 1200px)
		box-shadow: none
		border-radius: 0
		background-color: transparent
		overflow: visible

	.progress-row
		display: grid
		grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr
		grid-column-gap: 1px
		width: 100%

		&:after
			content: ''

		@media (max-width: 1200px)
			display: flex

			&:after
				content: 'flickity'
				display: none

		.flickity-viewport
			width: 100%

			@media (max-width: 1200px)
				overflow: visible

		.progress-column
			height: 75px
			padding: 0 22px
			align-items: center
			position: relative
			display: flex
			justify-content: space-between

			@media (max-width: 1200px)
				display: inline-flex
				width: 75%
				border-right: 1px solid #e9e9e9

			&:after
				content: ''
				height: 5px
				position: absolute
				bottom: 0
				left: 0
				right: 0

			&.stage-editable
				cursor: pointer
				transition: all 300ms

			.text-inner
				display: flex
				align-items: center

			.admin-control
				left: 0
				right: 0
				position: absolute
				bottom: 5px
				height: 30px
				background-color: #333
				display: flex
				align-items: center
				justify-content: center
				color: #fff
				font-size: 13px
				font-weight: 400

				ul
					display: flex
					width: 100%
					height: 30px

					li
						padding: 0 10px
						width: 100%
						font-family: 'Roboto Condensed', sans-serif
						display: flex
						justify-content: center
						align-items: center
						transition: all 300ms
						cursor: pointer
						height: 30px
						border-right: 1px solid rgba(#fff, 0.3)

						&:hover
							background-color: rgba(#fff, 0.2)

						&:last-child
							border-right: none

			&.stage-todo
				background-color: rgba(#edc7b7, 0.3)

				&:after
					background-color: #edc7b7

				&.stage-editable
					&:hover
						background-color: rgba(#edc7b7, 0.2)

			&.stage-pending
				background-color: rgba(#edc7b7, 0.3)

				&:after
					background-color: #edc7b7

				&.stage-editable
					&:hover
						background-color: rgba(#edc7b7, 0.2)

			&.mild-stage-highlight
				background-color: rgba(#70c2ff, 0.1)

				&:after
					background-color: rgba(#70c2ff, 0.5)

			&.stage-done
				background-color: rgba(#5aae4b, 0.3)

				&:after
					background-color: #5aae4b

				&.stage-editable
					&:hover
						background-color: rgba(#5aae4b, 0.2)

			&.stage-scheduled
				background-color: rgba(#fff, 0.3)

				.title
					font-weight: 700 !important

				&:after
					background-color: #5aae4b

				&.stage-editable
					&:hover
						background-color: rgba(#fff, 0.2)

			&.stage-current
				background-color: rgba(#70c2ff, 0.3)

				.title
					font-weight: 700 !important

				&:after
					background-color: #70c2ff

				&.stage-editable
					&:hover
						background-color: rgba(#70c2ff, 0.2)

			

			.title
				font-family: 'Roboto Condensed', sans-serif
				font-size: 14px
				color: #252525
				font-weight: 400
				line-height: 1.2

			.icon
				height: 60px
				display: flex
				align-items: center

				.fal
					color: #5aae4b

				.circle-blue
					width: 11px
					height: 11px
					border-radius: 50%
					background-color: #70c2ff

				.circle-pink
					width: 11px
					height: 11px
					border-radius: 50%
					background-color: #edc7b7
				
				.circle-green
					width: 11px
					height: 11px
					border-radius: 50%
					background-color: #5aae4b

			&.admin-mode
				height: 100px
				align-items: flex-start
				padding: 5px 22px

	&.advanced
		min-height: 100px

		.progress-row
			.progress-column
				height: 100px

				&:after
					height: 7px

				.number
					font-size: 42px
					font-family: 'Roboto Condensed', sans-serif
					font-weight: 700
					margin-right: 10px

				.title
					line-height: 1.2

					.subtext
						line-height: 1.2
						text-transform: capitalize

				.icon
					.fal
						font-size: 24px

					.circle-green
						width: 15px
						height: 15px

					.circle-blue
						width: 15px
						height: 15px

					.circle-pink
						width: 15px
						height: 15px

				&.stage-todo
					background-color: #fff

					.number
						color: #edc7b7

					.subtext
						color: #B94817

				&.mild-stage-highlight
					background-color: rgba(#70c2ff, 0.1)

					.number, .subtext
						color: #70c2ff

				&.stage-done
					background-color: rgba(#5aae4b, 0.3)

					.number, .subtext
						color: #5aae4b
				
				&.stage-scheduled
					background-color: rgba(#fff, 0.3)

					.number, .subtext
						color: #5aae4b

				&.stage-current
					background-color: rgba(#70c2ff, 0.3)
					
					.number, .subtext
						color: #70c2ff

					.title
						font-weight: 700 !important


				


</style>
